import { Component, input, output, signal } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { LoadingButtonDirective } from "@premotec/pmt-bootstrap";

@Component({
    selector: 'app-legacy-login-card',
    standalone: true,
    imports: [TranslocoDirective, LoadingButtonDirective],
    templateUrl: './legacy-login-card.component.html',
    styleUrl: './legacy-login-card.component.scss'
})
export class LegacyLoginCardComponent {
    public isLoading = input(false);
    public disabled = input(false);
    public loginButtonClicked = output();
    protected isCollapsed = signal(true);

    protected toggleCollapse(): void {
        this.isCollapsed.set(!this.isCollapsed());
    }
}